import { constants, typographyStyles } from "@newsela/angelou";

const { colors } = constants;
const { textSObj } = typographyStyles;

export const rootCss = {
  ...textSObj,
  display: "flex",
  backgroundColor: colors.brand.blue[25],
  color: colors.ui.core[700],
  borderRadius: "10px",
  padding: "16px",
  margin: "16px",
};

export const textCss = {
  margin: 0,
  lineHeight: "24px",
};

export const iconCss = {
  margin: "2px 8px 0 0",
  width: "100%",
  maxWidth: "18px",
  height: "100%",
  maxHeight: "18px",

  circle: {
    fill: colors.ui.core[700],
  },

  path: {
    stroke: colors.ui.white[700],
  },
};
